import React from 'react';
import CustomYearDatePicker from '../Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import CustomMonthDatePicker from '../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js'; // For range mode
import headerStyles from '../ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import './dateFilter.css'; // See CSS below

const DateFilterBar = ({
  t,
  direction,
  fetchType,
  isMatchDate,
  isRange,
  startDate,
  endDate,
  handleEndDateChangeNew,
  handleStartDateChangeNew,
  handleRangeChange,
  handleRangeSet,
  inline = false,
}) => {
  // Inline bars sit next to the card/currency pickers, so match their 8px corners.
  const pickerRadius = inline ? '8px' : undefined;

  return (
    <div
      className={`searchFilter-bar__container ${direction}${inline ? ' date-filter-inline' : ''}`}
      style={inline ? undefined : { marginBottom: '10px' }}
    >
      {fetchType === 'Matched' ? (
        <div className="date-toggle-group">
          <div style={{ width: "160px", minWidth: "0" }}>
          <CustomYearDatePicker
            date={endDate}
            onDateChange={(newYear) => handleEndDateChangeNew(newYear, false)}
            label={t("Year")}
            height="40px"
            borderRadius={pickerRadius}
          />
          </div>
          <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
            <span>{t(isMatchDate ? 'MatchDate' : 'Document Date')}</span>
            <input
              type="checkbox"
              checked={isMatchDate}
              onChange={(e) => handleRangeChange(e, e.target.checked)}
            />
            <span className={headerStyles.switchTrack} aria-hidden="true" />
          </label>
        </div>
      ) : (
        <div className="date-toggle-group">
          {isRange ? (
            <>
            <div style={{ width: "160px", minWidth: "0" }}>
              <CustomMonthDatePicker
                onDateChange={(date) => handleStartDateChangeNew(date, true)}
                date={startDate}
                label={t('StartDate')}
                height="40px"
                borderRadius={pickerRadius}
              />
              </div>
              <div style={{ width: "160px", minWidth: "0" }}>
              <CustomMonthDatePicker
                onDateChange={(date) => handleEndDateChangeNew(date, true)}
                date={endDate}
                label={t('EndDate')}
                height="40px"
                borderRadius={pickerRadius}
              />
              </div>
            </>
          ) : (
            <div style={{ width: "160px", minWidth: "0" }}>
            <CustomYearDatePicker
              onDateChange={(date) => handleEndDateChangeNew(date)}
              date={endDate}
              label={t("Year")}
              borderRadius={pickerRadius}
            />
            </div>
          )}
          <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
            <span>{t('DateRange')}</span>
            <input
              type="checkbox"
              checked={isRange}
              onChange={(e) => handleRangeSet(e.target.checked)}
            />
            <span className={headerStyles.switchTrack} aria-hidden="true" />
          </label>
        </div>
      )}
    </div>
  );
};

export default DateFilterBar;
